import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { spacing } from 'ui/theme';

export const DefineFieldTypeCSSContainer = styled.div<{ isViewMode: boolean }>`
  &&&&& {
    .coreTableHeaderRow {
      z-index: unset;
    }
    .highlightedFieldTypes,
    .highlightedConfirmFieldTypes {
      display: flex;
      align-items: center;
      background: #fdf3eb;
      margin: 0;
      padding: 10px;
      border-left: 1px solid #f1b580;
      border-right: 1px solid #f1b580;
      height: 100%;
      > span {
        margin-left: 5px;
      }
    }
    .highlightedConfirmFieldTypes {
      background: #eaf9f0;
      border-color: #78d9a0;
      line-height: 2.2;
    }
    [role='listbox'] {
      max-height: 140px;
    }
    div[data-role='body'] {
      overflow-y: visible;
      padding-bottom: 130px;
    }
    ${({ isViewMode }) => {
      return isViewMode
        ? ''
        : `
      div[data-role='row']:last-child {
        .highlightedFieldTypes,
        .highlightedConfirmFieldTypes {
          border-bottom: 1px solid #e98b39;
        }
        .highlightedConfirmFieldTypes {
          border-color: #2cc36b;
        }
      }
      div[data-role='row']:nth-child(2) {
        .highlightedFieldTypes,
        .highlightedConfirmFieldTypes {
          border-top: 1px solid ##e98b39;
        }
        .highlightedConfirmFieldTypes {
          border-color: #2cc36b;
        }
      }
      div[data-role='cell'] {
        z-index: unset;
        overflow: unset;
        padding-top: 0;
        padding-bottom: 0;
        max-width: 200px;
        > div {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          padding: 5px 0;
          &[name='Field type'] {
            padding: 0;
            overflow: unset;
            white-space: unset;
          }
        }
      }
      `;
    }}
  }
`;

export const FieldTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.double};
`;

export const MessageContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  gap: ${spacing.base};
`;

export const StyledWarningBanner = styled(WarningBanner)`
  display: flex;
  align-items: center;
`;

export const MultiSelectContainer = styled.div`
  margin-left: auto;
`;
